import {fetch} from '..';
import {QueryMethod} from '../utils';
import {UserDetailsDto} from './dto';

export function getUserDetails() {
  return fetch<UserDetailsDto>(
    '/gogeta-api/v1/user-details',
    QueryMethod.GET,
  );
}

export function getUserRemainingBalance() {
  return fetch<number>(
    '/v1/user/user-remaining-balance',
    QueryMethod.GET
  );
}
